import { render } from "./SideBarSubMenu.vue?vue&type=template&id=521fa370&scoped=true"
import script from "./SideBarSubMenu.vue?vue&type=script&lang=js"
export * from "./SideBarSubMenu.vue?vue&type=script&lang=js"

import "./SideBarSubMenu.vue?vue&type=style&index=0&id=521fa370&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521fa370"]])

export default __exports__